const style = {
  ssoDetails__loginURL: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
};

export default style;
